import { render, staticRenderFns } from "./side-bar.vue?vue&type=template&id=63c75ea6&"
import script from "./side-bar.ts?vue&type=script&lang=ts&"
export * from "./side-bar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports